import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib/dist/hooks';
import { EMPLOYEE_PROFILE_TEST_IDS } from '../constants';
import {
  InactiveTasksWrapperStyled,
  NoTasksTitleStyled,
  SectionTitleStyled,
  SubscriberTasksListStyled,
  TasksWrapperStyled,
} from './styles';
import SubscriberTask from './SubscriberTask';

// TODO: Should be covered with tests after the store refactoring.
// Currently, it’s too tightly coupled to the old stores to test properly.

const EmployeeProfile = observer((): JSX.Element => {
  const {
    employeeElectionsStore: { checkElectionForCompleted, isElectionCompleted, loading },
    subscriberStore: { activePeriods, subscriberTasks, subscriberId },
  } = useRootStore();

  const query = useQueryParams();
  const groupId = query.get('groupId') || '';

  const convertedActivePeriods = activePeriods.map((period) => toJS(period)).slice();
  const activeSubscriberTasks = toJS(subscriberTasks.active)
    .map((task) => toJS(task))
    .slice();

  const inactiveSubscriberTasks = toJS(subscriberTasks.inactive)
    .map((task) => toJS(task))
    .slice();

  const activePeriod = convertedActivePeriods[0];
  const activePeriodId = activePeriod?.id || '';

  const history = useHistory();

  function onTaskChecklistRedirect(taskId: string): void {
    history.push(`/subscriber-task-checklist/${groupId}?subId=${subscriberId}&entityId=${taskId}`);
  }

  useEffect(() => {
    if (activePeriodId) {
      void checkElectionForCompleted(activePeriodId);
    }
  }, [activePeriodId]);

  return (
    <>
      {!loading && (
        <>
          {(convertedActivePeriods.length === 0 || isElectionCompleted) && activeSubscriberTasks.length === 0 && (
            <NoTasksTitleStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.NO_ACTIVE_TASKS_MESSAGE}>
              No Active Tasks
            </NoTasksTitleStyled>
          )}

          {activeSubscriberTasks.length > 0 && (
            <TasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.ACTIVE_TASKS_SECTION}>
              <SectionTitleStyled>Active Tasks</SectionTitleStyled>
              <SubscriberTasksListStyled>
                {activeSubscriberTasks.map((task) => (
                  <SubscriberTask
                    key={task.entityId}
                    task={task}
                    onRedirect={(): void => onTaskChecklistRedirect(task.entityId)}
                  />
                ))}
              </SubscriberTasksListStyled>
            </TasksWrapperStyled>
          )}

          {inactiveSubscriberTasks.length > 0 && (
            <InactiveTasksWrapperStyled data-test-id={EMPLOYEE_PROFILE_TEST_IDS.INACTIVE_TASKS_SECTION}>
              <SectionTitleStyled>Inactive Tasks</SectionTitleStyled>
              <SubscriberTasksListStyled>
                {inactiveSubscriberTasks.map((task) => (
                  <SubscriberTask
                    key={task.entityId}
                    task={task}
                    onRedirect={(): void => onTaskChecklistRedirect(task.entityId)}
                  />
                ))}
              </SubscriberTasksListStyled>
            </InactiveTasksWrapperStyled>
          )}
        </>
      )}
    </>
  );
});

export default EmployeeProfile;
